import { useWorkoutEditStore } from "./WorkoutEditContext";

// Writes to an exercise's main item or its alternates run one at a time, so
// making an alternate main swaps only after earlier writes land.
export function useWorkoutItemMutationScope(workoutItemId: string) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getWorkoutItemById(workoutItemId);
  const mainWorkoutItemId =
    workoutItem.type === "ALTERNATE" ? workoutItem.parentId : workoutItem.id;

  return { id: `workoutItem:${mainWorkoutItemId}` };
}
